import React from 'react';
import './About.css';
import { Col, Container, ListGroup, Row, Image } from 'react-bootstrap';
import Slide from 'react-reveal/Slide';
import Skills from '../Skills/Skills';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin, faMedium } from '@fortawesome/free-brands-svg-icons';
import Typical from 'react-typical';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

const About = () => {
  const steps = [
    'Front-End Developer', 3000,
    'Love To Explore Myself', 2000
  ];
  return (
    <>
      <Container id="aboutPage">
        <Row>
          <Col md={6} className="mt-5">
            <Slide left delay={500} duration={2000}>

              <div className="text-center">
                <h1 className="m-2 pb-2 title">About <span className="title-color">Me</span></h1>
                <div className="m-3 ">
                  <Image src="https://i.ibb.co/Yfc05gq/reya1.jpg" fluid thumbnail />
                </div>
                <Typical
                  steps={steps}
                  loop={Infinity}
                  wrapper="p"
                  className="custom-typical"
                />
                <p className="customP">
                  Hello, I'm <span className="title-color"> Reya</span>.  I like to introduce myself as a <span className="title-color"> dreamer</span>, <span className="title-color"> tenacious</span>, and a <span className="title-color"> problem solver</span>. When I create an <span className="title-color"> impressive</span> interactive dynamic website, it gives me a great <span className="title-color"> pleasure</span>. I prefer to keep <span className="title-color">learning</span> and continue <span className="title-color">challenging</span> myself.
                </p>
                <p> Feel free to reach out through any platforms below: </p>
                <ListGroup horizontal>
                  <ListGroup.Item>
                    <a
                      href="https://www.linkedin.com/in/jannatun-naher-759a17185/"
                      target="_blank"
                      rel="noreferrer">
                      <FontAwesomeIcon
                        className="custom-icon"
                        icon={faLinkedin} />
                    </a>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <a
                      href="https://github.com/reya3183"
                      target="_blank"
                      rel="noreferrer">
                      <FontAwesomeIcon
                        className="custom-icon"
                        icon={faGithub} />
                    </a>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <a
                      href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=rianaher777@gmail.com"
                      target="_blank"
                      rel="noreferrer">
                      <FontAwesomeIcon
                        className="custom-icon"
                        icon={faEnvelope} />
                    </a>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <a
                      href="https://reya3183.medium.com/"
                      target="_blank"
                      rel="noreferrer">
                      <FontAwesomeIcon
                        className="custom-icon"
                        icon={faMedium} />
                    </a>
                  </ListGroup.Item>
                </ListGroup>
              </div>

            </Slide>
          </Col>
          <Col md={6}>
            <Slide right delay={500} duration={2000}>
              <Skills></Skills>
            </Slide>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default About;